import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((config) => {
  const mid = localStorage.getItem("activeMaisonId");
  if (mid && mid !== "all") config.headers["X-Maison-Id"] = mid;
  return config;
});

export function formatApiError(detail) {
  if (detail == null) return "Une erreur est survenue. Réessayez.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

async function downloadBlob(path, filename) {
  const res = await api.get(path, { responseType: "blob" });
  const url = window.URL.createObjectURL(new Blob([res.data]));
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", filename);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
}

export async function downloadOrderPdf(payload) {
  const res = await api.post("/inc/order-pdf", payload, { responseType: "blob" });
  const url = window.URL.createObjectURL(new Blob([res.data]));
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", "bon_de_commande_incontinence.pdf");
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
}

export async function downloadFichesPdf(payload) {
  const res = await api.post("/inc/fiches-pdf", payload, { responseType: "blob" });
  const url = window.URL.createObjectURL(new Blob([res.data]));
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", "fiches_incontinence.pdf");
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
}

export const downloadExcel = (collection) => downloadBlob(`/export/${collection}`, `caredesk_${collection}.xlsx`);
export const downloadOrdersExport = () => downloadBlob(`/inc/orders/export`, `caredesk_commandes_incontinence.xlsx`);
export const downloadPdf = (collection) => downloadBlob(`/export/pdf/${collection}`, `caredesk_${collection}.pdf`);
export const downloadCrmExcel = () => downloadBlob(`/crm/export/excel`, `caredesk_suivi_commercial.xlsx`);
export const downloadCrmPdf = () => downloadBlob(`/crm/export/pdf`, `caredesk_suivi_commercial.pdf`);
export const downloadGroupOverview = (format = "xlsx") =>
  downloadBlob(`/crm/export/group-overview?format=${format}`, `carepilot_pilotage_groupe.${format === "pdf" ? "pdf" : "xlsx"}`);
export const downloadAttestation = (nom, prenom = "", year = "") =>
  downloadBlob(
    `/export-attestation?nom=${encodeURIComponent(nom)}&prenom=${encodeURIComponent(prenom)}${year ? `&year=${encodeURIComponent(year)}` : ""}`,
    `attestation_${nom}_${prenom}.pdf`.replace(/\s+/g, "_")
  );
